import { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export function HeaderProvider({ children }) {
    const [showPauseButton, setShowPauseButton] = useState(false);
    const [progressRequested, setProgressRequested] = useState(false);
    const [progress, setProgress] = useState(0);
    const [journey, setJourney] = useState(null);
    const [currentStepId, setCurrentStepId] = useState(null);

    return (
        <HeaderContext.Provider value={{
            showPauseButton, setShowPauseButton,
            progressRequested, setProgressRequested,
            progress, setProgress,
            journey, setJourney,
            currentStepId, setCurrentStepId
        }}>
            {children}
        </HeaderContext.Provider>
    );
}

export function useHeader() {
    return useContext(HeaderContext);
}
